export const paths = ['/field-stream'];
